package com.bikompanion.domain

/** Which colour scheme the rider asked for. [Auto] follows the system setting. */
enum class ThemeMode {
    Auto,
    Light,
    Dark,
}
